/**
 * Created by DejanK on 7/10/2017.
 */
import angular from 'angular'

import rbFixedOnScrollContainer from './rb-fixed-on-scroll-container.dir'
import rbFixedOnScrollY from './rb-fixed-on-scroll-y.dir'
import rbOpacityOnScrollY from './rb-opacity-on-scroll-y.dir'

export default angular.module('rb.rb-fixed-on-scroll', [])
  .directive('rbFixedOnScrollContainer', rbFixedOnScrollContainer)
  .directive('rbFixedOnScrollY', rbFixedOnScrollY)
  .directive('rbOpacityOnScrollY', rbOpacityOnScrollY)
